export default {
      id: "view-document-usage",
      viewBox: "0 0 24 28",
      url: __webpack_public_path__ + "img/icons.svg#view-document",
      toString: function () {
        return this.url;
      }
    }